// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";

import { mdiArrowCollapseUp } from "@mdi/js";
import { Tooltip } from "antd";

import { ShapefileAction } from "../..";

interface IShapefileMoveToTopActionProps {
  isDisabled?: boolean;
  moveToTop: () => void;
  onContextMenuClose?: () => void;
}

export function ShapefileMoveToTopAction({
  isDisabled,
  moveToTop,
  onContextMenuClose
}: IShapefileMoveToTopActionProps) {
  return (
    <Tooltip title="Move to top of all shapefiles" placement="right">
      <ShapefileAction
        disabled={isDisabled}
        onClick={(evt) => {
          moveToTop();
          onContextMenuClose?.();
          evt.stopPropagation();
          evt.preventDefault();
        }}>
        <Icon path={mdiArrowCollapseUp} size={"18px"} />
        Move to Top
      </ShapefileAction>
    </Tooltip>
  );
}
